import { Box, Tag } from '@factorialco/deprecated-design-system'

export const ExpensablesCount = ({ count }: { count: number }) => {
  return (
    <Box flexDirection="row" alignItems="center" gap="s8">
      <Box flexDirection="row" alignItems="center" gap="s6" width="s140">
        <Tag type="grey">{count}</Tag>
      </Box>
    </Box>
  )
}
